import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.getResolvedTitleForRoute(routerState.root);
    if (title !== undefined) {
      this.title.setTitle(`${title} - ThiemeMeulenhoff`);
    } else {
      this.title.setTitle('ThiemeMeulenhoff');
    }
  }
}
